import * as React from 'react'
// components
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE } from 'components/UI'
// hooks
import { useShowModal } from 'hooks'
// constants
import { Modals } from 'constants/modals'

const CreateSystemProcessButton: React.FC = () => {
  const { showModal } = useShowModal({ modalType: Modals.SYSTEM_PROCESS_CREATE_MODAL })

  const createSystemProcess = () => showModal()

  return (
    <Button
      data-testid='create-system-process'
      style={CREATE_BUTTON_STYLE}
      layout={BUTTON_LAYOUTS.PURPLE}
      onClick={createSystemProcess}>
      Create System Process
    </Button>
  )
}

export default CreateSystemProcessButton
